<template>
	<div class="omapi-courses__course omapi-omu__grid-item omapi-card__fourth">
		<a @click="maybeUpsell" :href="url" target="_blank" rel="noopener">
			<img v-if="img" :height="img.height" :width="img.width" :src="img.source_url"/>
		</a>
		<h4 class="omapi-courses__course-title">
			<a @click="maybeUpsell" :href="url" target="_blank" rel="noopener" v-html="course.title"/>
		</h4>
		<a @click="maybeUpsell" :href="url" target="_blank" rel="noopener" class="omapi-link-arrow-after omapi-link-underline">Start Course</a>
	</div>
</template>

<script lang="js">
import { debug } from '@/utils'
import { markingSso } from '@/components/mixins/markingSso'
import { upsell } from '@/university/mixins/upsell'

export default  {
	mixins : [ markingSso, upsell ],
	data () {
		return {
			utmMedium : 'UniversityCourse',
		}
	},
	props : {
		course : {
			type     : Object,
			required : true,
		},
	},
	computed : {
		url () {
			return this.marketingUrl(this.course.link, 'University')
		},
		img () {
			let { img } = this.course

			if (img && debug.enabled('course-media')) {
				img.source_url = img.source_url.replace('optinmonster.test', 'optinmonster.com')
			}

			return img
		},
	},
}
</script>
